import React from 'react';
import { Services } from './Services/Services';
import { HomeDivider } from '../Homepage/HomeDivider';
import { Appointment } from '../Mobile/Homepage/Appointment/Appointment';

export const MobileServicesPage = () => {
	return (
		<div>
			<Services />
			<HomeDivider />
			<Appointment />
		</div>
	);
};
